var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"color":"#282a36","dark":""}},[_c('v-toolbar-title',[_vm._v("Vuelife")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","href":"https://github.com/caiopeternela/pylifeandvuelife","target":"_blank"}},[_c('v-icon',[_vm._v("mdi-github")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }